window.localUsabilityClickElements = {
  'button[data-target="#header-main-navi-nav"][aria-expanded="false"]': {
    //Menü-Button wird geöffnet
    'type': 'action',
    'click': 'Das Menü wurde geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Menü wird geöffnet'
  },
  'button[data-target="#header-main-navi-nav"][aria-expanded="true"]': {
    //Menü-Button wird geschlossen
    'type': 'action',
    'click': 'Das Menü wurde geschlossen',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Menü wird geschlossen'
  },
  '#header-main-navi-nav a:not([rel*="external"])': {
    //Interner Link im Menü
    'type': 'navigation',
    'click': 'Navigation via Menüpunkt "{INNER-TEXT}"',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#header-main-navi-nav a[rel*="external"]': {
    //Externer Link im Menü
    'type': 'exit',
    'click': 'Navigation via Menüpunkt "{INNER-TEXT}"',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.planet-search .panel button[data-toggle="collapse"][aria-expanded="false"]': {
    //Filterbereich wird geöffnet
    'type': 'action',
    'click': 'Filter-Bereich der Suche wurde geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': ''
  },
  '.planet-search .panel button[data-toggle="collapse"][aria-expanded="true"]': {
    //Filterbereich wird geschlossen
    'type': 'action',
    'click': 'Filter-Bereich der Suche wurde geschlossen',
    'click_chapter1': 'Menü',
    'click_chapter3': ''
  },
  '#faecher-tab[aria-selected="false"]': {
    //Filterbereich Fach wird geöffnet
    'type': 'action',
    'click': 'Filter-Optionen wurden geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Fach"'
  },
  '#faecher-tab[aria-selected="true"]': {
    //Filterbereich Fach wird geschlossen
    'type': 'action',
    'click': 'Filter-Optionen wurden geschlossen',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Fach"'
  },
  '#klassen-tab[aria-selected="false"]': {
    //Filterbereich Klasse wird geöffnet
    'type': 'action',
    'click': 'Filter-Optionen wurden geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Klasse"'
  },
  '#klassen-tab[aria-selected="true"]': {
    //Filterbereich Klasse wird geschlossen
    'type': 'action',
    'click': 'Filter-Optionen wurden geschlossen',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Klasse"'
  },
  '#medien-tab[aria-selected="false"]': {
    //Filterbereich Medientyp wird geöffnet
    'type': 'action',
    'click': 'Filter-Optionen wurden geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Medientyp"'
  },
  '#medien-tab[aria-selected="true"]': {
    //Filterbereich Medientyp wird geschlossen
    'type': 'action',
    'click': 'Filter-Optionen wurden geschlossen',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Medientyp"'
  },
  '#planet-faecher button.btn-filter': {
    //Filter anwenden im Bereich Fach geklickt
    'type': 'action',
    'click': 'Button "Filter anwenden" wurde geklickt',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Fach"'
  },
  '#planet-klassen button.btn-filter': {
    //Filter anwenden im Bereich Klasse geklickt
    'type': 'action',
    'click': 'Button "Filter anwenden" wurde geklickt',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Klasse"'
  },
  '#planet-medien button.btn-filter': {
    //Filter anwenden im Bereich Medientyp geklickt
    'type': 'action',
    'click': 'Button "Filter anwenden" wurde geklickt',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Filter-Bereich "Medientyp"'
  },
  '.more-linking a[rel*="external"]': {
    //Externer Link "Mehr zum Thema"
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Block "Mehr"',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#footer a[rel*="external"]': {
    //Externer Link im Footer
    'type': 'exit',
    'click': 'Navigation via Link im Footer zu "{INNER-TEXT}"',
    'click_chapter1': 'Footer',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .inline-link[rel*="external"]': {
    //Externer Link im Copytext
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Copytext',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .linkliste a[rel*="external"]': {
    //Externer Link in Multibox
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link in Multibox',
    'click_chapter3': '{ZIEL-URL}'
  },
}
